import { render, staticRenderFns } from "./RechazarPallets.vue?vue&type=template&id=590b2182&"
import script from "./RechazarPallets.vue?vue&type=script&lang=js&"
export * from "./RechazarPallets.vue?vue&type=script&lang=js&"
import style0 from "./RechazarPallets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports